/** Height the templates' screen-height utilities resolve to inside an auto-height frame (JUB-210). */
export const DEFAULT_VIEWPORT_HEIGHT = 800;

/** Safety net against any future feedback loop between the frame and its document. */
export const MAX_AUTO_HEIGHT = 12000;

/**
 * Pins the screen-height utilities the templates use (golden_serenity, botez_bokeh and
 * the retired ones) to a fixed height. Inside an iframe 100vh is the frame itself, so a
 * `min-h-screen` hero would grow with every fit of an auto-height frame.
 */
export function viewportPinCss(height: number) {
  const px = `${height}px`;
  return [
    `.min-h-screen,.min-h-\\[100dvh\\],.min-h-\\[100svh\\],.min-h-\\[100vh\\]{min-height:${px}!important}`,
    `.h-screen,.h-\\[100dvh\\],.h-\\[100svh\\],.h-\\[100vh\\]{height:${px}!important}`,
  ].join("");
}
